import React, { useEffect, useState } from "react";
import { View } from "react-native";

import {
  Input,
  Picker,
  InputLabel,
  CityPicker,
  DatePicker,
  ParentCatPicker,
} from "components";
import FiltersTemplate from "screens/components/FiltersTemplate";

import { strings } from "assets/constants";
import { filtersItems } from "assets/data";
import css from "styles";

import { useCustomerBaseOptions, useCustomerStatus } from "clients/apis";

export interface CustomersFilterT {
  phone?: string;
  birthday?: string;
  passed_cheque_amount?: string;
  popular_category?: PickerItemT;
  frindship?: PickerItemT;
  city?: PickerItemT;
  status?: RadioButtonItemT;
}

export default function Filters(props: {
  visible: boolean;
  hide?: () => void;
  initials: CustomersFilterT;
  apply?: (newFilters: CustomersFilterT) => void;
}) {
  const { data: customerStatus } = useCustomerStatus();
  const { data: customerBaseOptions } = useCustomerBaseOptions();

  const { initials, hide, apply, visible } = props;

  const [innerFilters, setInnerFilters] = useState(initials);

  useEffect(() => setInnerFilters(initials), [initials]);

  const _onApply = () => apply && apply(innerFilters);
  const _onCancel = () => {
    setInnerFilters(initials);
    hide && hide();
  };

  return (
    <FiltersTemplate
      filtersItems={filtersItems.customers}
      innerFilters={innerFilters}
      setInnerFilters={setInnerFilters}
      visible={visible}
      _onApply={_onApply}
      _onCancel={_onCancel}
    >
      <>
        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.phone_number} />
          <Input
            value={innerFilters.phone === undefined ? "" : innerFilters.phone}
            onChangeText={(phone) =>
              setInnerFilters({ ...innerFilters, phone })
            }
            placeholder={strings.insert_phone_number}
            keyboardType="phone-pad"
            icon={{ name: "phone" }}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.type} />
          <Picker
            icon={{ name: "list" }}
            value={innerFilters?.status?.title}
            placeholder={strings.pick_customer_type}
            data={customerStatus?.data || []}
            onSelect={(status) => setInnerFilters({ ...innerFilters, status })}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.familiarity_way} />
          <Picker
            onSelect={(frindship) =>
              setInnerFilters({ ...innerFilters, frindship })
            }
            value={innerFilters?.frindship?.title}
            data={customerBaseOptions?.data?.frindship?.original?.data?.items}
            icon={{ name: "airplay" }}
            placeholder={strings.pick_customer_familiarity_way}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.city} />
          <CityPicker
            value={innerFilters.city}
            onSelect={(city) => setInnerFilters({ ...innerFilters, city })}
            placeholder={strings.pick_city}
            icon={{ name: "map-pin" }}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.popular_categories} />
          <ParentCatPicker
            showChild
            value={innerFilters.popular_category}
            placeholder={strings.pick_product_cat}
            onSelect={(popular_category) =>
              setInnerFilters({ ...innerFilters, popular_category })
            }
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.birthday} />
          <DatePicker
            value={innerFilters.birthday}
            onSelect={(birthday) =>
              setInnerFilters({ ...innerFilters, birthday })
            }
            placeholder={strings.pick_birthday}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.passed_cheque_amount} />

          <Input
            value={
              innerFilters.passed_cheque_amount === undefined
                ? ""
                : innerFilters.passed_cheque_amount
            }
            onChangeText={(passed_cheque_amount) =>
              setInnerFilters({ ...innerFilters, passed_cheque_amount })
            }
            icon={{ name: "bar-chart" }}
            keyboardType="number-pad"
            placeholder={strings.insert_max_passed_cheque}
            enablePriceFormatter
          />
        </View>
      </>
    </FiltersTemplate>
  );
}
